import React, { useEffect, useState, useRef } from 'react';
import { BellIcon, UserIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
interface VeliHeaderProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
}
export function VeliHeader({
  isMobileMenuOpen,
  setIsMobileMenuOpen
}: VeliHeaderProps) {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  // MOCK BİLDİRİMLER VERİSİ (Gerçek uygulamada API'den gelecek)
  const [notifications, setNotifications] = useState([{
    id: 1,
    read: false,
    type: 'exam_result',
    title: 'LGS Deneme-5 Sonucu'
  }, {
    id: 2,
    read: false,
    type: 'performance_warning',
    title: 'Matematik Performansı Uyarısı'
  }, {
    id: 3,
    read: false,
    type: 'homework_missing',
    title: 'Teslim Edilmeyen Ödev'
  }, {
    id: 4,
    read: true,
    type: 'daily_study',
    title: 'Günlük Çalışma Özeti'
  }, {
    id: 5,
    read: false,
    type: 'teacher_message',
    title: 'Öğretmenden Yeni Mesaj'
  }, {
    id: 6,
    read: true,
    type: 'system_update',
    title: 'Platform Güncellemesi'
  }, {
    id: 7,
    read: false,
    type: 'schedule_delay',
    title: 'Program Gecikmesi'
  }, {
    id: 8,
    read: false,
    type: 'meeting_request',
    title: 'Veli Görüşme Talebi'
  }]);
  // DİNAMİK BİLDİRİM SAYACI
  const [unreadCount, setUnreadCount] = useState(0);
  // OKUNMAMIŞ SAYISINI HESAPLA
  useEffect(() => {
    const unreadNotifications = notifications.filter(notification => !notification.read);
    setUnreadCount(unreadNotifications.length);
  }, [notifications]);
  // Bildirim okunduğunda sayıyı azalt
  const markNotificationAsRead = notificationId => {
    setNotifications(prev => prev.map(notification => notification.id === notificationId ? {
      ...notification,
      read: true
    } : notification));
  };
  // Yeni bildirim geldiğinde sayıyı artır
  const addNewNotification = newNotification => {
    setNotifications(prev => [{
      ...newNotification,
      read: false,
      id: Date.now()
    }, ...prev]);
  };
  // Tüm bildirimleri okundu işaretle
  const markAllAsRead = () => {
    setNotifications(prev => prev.map(notification => ({
      ...notification,
      read: true
    })));
  };
  // Outside click handler
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
        setShowProfileMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="flex items-center justify-between w-full" data-id="element-723">
      {/* Hamburger Menu Button - Only visible on mobile */}
      <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-white/5 transition-colors" data-id="element-724">
        <MenuIcon className="w-6 h-6 text-gray-300" data-id="element-725" />
      </button>
      <div className="flex items-center justify-center gap-6" data-id="element-726">
        {/* Bildirim Zili */}
        <div className="relative" ref={notificationRef} data-id="element-727">
          <button className="relative hover:scale-105 transition-transform duration-200" onClick={() => navigate('/bildirimler')} data-id="element-728">
            <BellIcon className="w-12 h-12 text-gray-300 hover:text-blue-400 transition-colors" data-id="element-729" />
            {/* DİNAMİK SAYAÇ - GERÇEK VERİYE GÖRE */}
            {unreadCount > 0 && <span className="absolute -top-3 -right-3 min-w-[28px] h-7 bg-red-500 text-white text-base rounded-full flex items-center justify-center font-bold border-2 border-black px-1" data-id="element-730">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>}
          </button>
        </div>
        {/* Profil Menüsü */}
        <div className="relative" ref={profileRef} data-id="element-731">
          <button onClick={() => setShowProfileMenu(!showProfileMenu)} className="relative group" data-id="element-732">
            <div className="relative w-14 h-14 rounded-full overflow-hidden ring-2 ring-transparent group-hover:ring-blue-500 transition-all" data-id="element-733">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=faces" alt="Profile" className="w-full h-full object-cover" data-id="element-734" />
            </div>
          </button>
          {/* PROFİL DROPDOWN MENU */}
          {showProfileMenu && <div className="fixed inset-x-4 top-32 sm:absolute sm:inset-auto sm:right-0 sm:top-full sm:mt-2 w-auto sm:w-64 z-50" data-id="element-735">
              <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-736">
                <div className="bg-black/90 rounded-xl divide-y divide-gray-800" data-id="element-737">
                  {/* VELİ BİLGİLERİ */}
                  <div className="p-4" data-id="element-738">
                    <div className="flex items-center gap-3" data-id="element-739">
                      <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=faces" alt="Profile" className="w-10 h-10 rounded-full" data-id="element-740" />
                      <div className="flex-1 min-w-0" data-id="element-741">
                        <p className="text-sm font-medium" data-id="element-742">Mehmet Demir</p>
                        <p className="text-xs text-gray-400 truncate" data-id="element-743">
                          Veli Hesabı
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* PROFİL LİNKİ */}
                  <div className="p-2" data-id="element-744">
                    <Link to="/profil" onClick={() => setShowProfileMenu(false)} className="flex items-center gap-2 w-full p-2 text-left text-sm rounded-lg hover:bg-white/5 transition-colors" data-id="element-745">
                      <UserIcon className="w-4 h-4" data-id="element-746" />
                      Profili Görüntüle
                    </Link>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}